<template><section><h1>Message 消息提示</h1>
<p>常用于主动操作后的反馈提示</p>
<h3>基础用法</h3>
<p>从顶部出现，3 秒后自动消失。</p>

<demo-block>
                <div class="source" slot="source"><ayu-button @click="open()">打开消息提示</ayu-button>

</div>
                <p>使用$message方法调用message组件，接收对象中的content</p>

                <div class="highlight" slot="highlight"><pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">ayu-button</span> <span class="hljs-attr">@click</span>=<span class="hljs-string">"open()"</span>&gt;</span>打开消息提示<span class="hljs-tag">&lt;/<span class="hljs-name">ayu-button</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
  <span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
    <span class="hljs-attr">methods</span>: {
      open() {
        <span class="hljs-keyword">this</span>.$message({
          <span class="hljs-attr">content</span>: <span class="hljs-string">'我是一个message'</span>
        })
      }
    }
  }
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
</code></pre>
</div></demo-block>
<h3>不同状态</h3>
<p>用来显示「成功、警告、消息、错误」类的操作反馈。</p>
<demo-block>
                <div class="source" slot="source"><ayu-button @click="open1()">成功</ayu-button>
<ayu-button @click="open2()">警告</ayu-button>
<ayu-button @click="open3()">消息</ayu-button>
<ayu-button @click="open4()">错误</ayu-button>


</div>
                <p>设置<code>type</code>字段可以定义不同的状态，默认为<code>info</code></p>

                <div class="highlight" slot="highlight"><pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">ayu-button</span> <span class="hljs-attr">@click</span>=<span class="hljs-string">"open1()"</span>&gt;</span>成功<span class="hljs-tag">&lt;/<span class="hljs-name">ayu-button</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">ayu-button</span> <span class="hljs-attr">@click</span>=<span class="hljs-string">"open2()"</span>&gt;</span>警告<span class="hljs-tag">&lt;/<span class="hljs-name">ayu-button</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">ayu-button</span> <span class="hljs-attr">@click</span>=<span class="hljs-string">"open3()"</span>&gt;</span>消息<span class="hljs-tag">&lt;/<span class="hljs-name">ayu-button</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">ayu-button</span> <span class="hljs-attr">@click</span>=<span class="hljs-string">"open4()"</span>&gt;</span>错误<span class="hljs-tag">&lt;/<span class="hljs-name">ayu-button</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
  <span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
    <span class="hljs-attr">methods</span>: {
      open1() {
        <span class="hljs-keyword">this</span>.$message({
          <span class="hljs-attr">type</span>: <span class="hljs-string">'success'</span>,
          <span class="hljs-attr">content</span>: <span class="hljs-string">'我是一个message'</span>
        })
      },
      open2() {
        <span class="hljs-keyword">this</span>.$message({
          <span class="hljs-attr">type</span>: <span class="hljs-string">'warning'</span>,
          <span class="hljs-attr">content</span>: <span class="hljs-string">'我是一个message'</span>
        })
      },
      open3() {
        <span class="hljs-keyword">this</span>.$message({
          <span class="hljs-attr">type</span>: <span class="hljs-string">'info'</span>,
          <span class="hljs-attr">content</span>: <span class="hljs-string">'我是一个message'</span>
        })
      },
      open4() {
        <span class="hljs-keyword">this</span>.$message({
          <span class="hljs-attr">type</span>: <span class="hljs-string">'error'</span>,
          <span class="hljs-attr">content</span>: <span class="hljs-string">'我是一个message'</span>
        })
      }
    }
  }
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
</code></pre>
</div></demo-block>
<h3>使用 HTML 片段</h3>
<p>message 属性支持传入 HTML 片段</p>
<demo-block>
                <div class="source" slot="source"><ayu-button @click="open5()">打开消息提示</ayu-button>

</div>
                
                <div class="highlight" slot="highlight"><pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">ayu-button</span> <span class="hljs-attr">@click</span>=<span class="hljs-string">"open5()"</span>&gt;</span>打开消息提示<span class="hljs-tag">&lt;/<span class="hljs-name">ayu-button</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
  <span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
    <span class="hljs-attr">methods</span>: {
      open5() {
        <span class="hljs-keyword">this</span>.$message({
          <span class="hljs-attr">content</span>: <span class="hljs-string">'&lt;strong&gt;这是 &lt;i&gt;HTML&lt;/i&gt; 片段&lt;/strong&gt;'</span>
        })
      }
    }
  }
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
</code></pre>
</div></demo-block>
<h3>自定义垂直偏移量</h3>
<demo-block>
                <div class="source" slot="source"><ayu-button @click="open6()">打开消息提示</ayu-button>

</div>
                <p>设置<code>verticalOffset</code>字段可以定义message的位置</p>

                <div class="highlight" slot="highlight"><pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">ayu-button</span> <span class="hljs-attr">@click</span>=<span class="hljs-string">"open6()"</span>&gt;</span>打开消息提示<span class="hljs-tag">&lt;/<span class="hljs-name">ayu-button</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
  <span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
    <span class="hljs-attr">methods</span>: {
      open6() {
        <span class="hljs-keyword">this</span>.$message({
          <span class="hljs-attr">content</span>: <span class="hljs-string">'这是一个message'</span>,
          <span class="hljs-attr">verticalOffset</span>: <span class="hljs-number">100</span>
        })
      }
    }
  }
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
</code></pre>
</div></demo-block>
<h3>关闭事件</h3>
<p>message消失执行onClose事件</p>
<demo-block>
                <div class="source" slot="source"><ayu-button @click="open7()">打开消息提示</ayu-button>

</div>
                
                <div class="highlight" slot="highlight"><pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">ayu-button</span> <span class="hljs-attr">@click</span>=<span class="hljs-string">"open7()"</span>&gt;</span>打开消息提示<span class="hljs-tag">&lt;/<span class="hljs-name">ayu-button</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
  <span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
    <span class="hljs-attr">methods</span>: {
      open7() {
        <span class="hljs-keyword">this</span>.$message({
          <span class="hljs-attr">content</span>: <span class="hljs-string">'这是一个message'</span>,
          <span class="hljs-attr">onClose</span>: <span class="hljs-function"><span class="hljs-params">()</span> =&gt;</span> {
            <span class="hljs-built_in">console</span>.log(<span class="hljs-string">'message close'</span>);
          }
        })
      }
    }
  }
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
</code></pre>
</div></demo-block>
<h3>Attributes</h3>
<table>
<thead>
<tr>
<th style="text-align:left">参数</th>
<th style="text-align:left">说明</th>
<th style="text-align:left">类型</th>
<th style="text-align:left">可选值</th>
<th style="text-align:left">默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td style="text-align:left">type</td>
<td style="text-align:left">类型</td>
<td style="text-align:left">String</td>
<td style="text-align:left">success/warning/info/error</td>
<td style="text-align:left">info</td>
</tr>
<tr>
<td style="text-align:left">verticalOffset</td>
<td style="text-align:left">垂直偏移量(px为单位)</td>
<td style="text-align:left">Number</td>
<td style="text-align:left">-</td>
<td style="text-align:left">30</td>
</tr>
<tr>
<td style="text-align:left">content</td>
<td style="text-align:left">提示内容</td>
<td style="text-align:left">String</td>
<td style="text-align:left">-</td>
<td style="text-align:left">-</td>
</tr>
<tr>
<td style="text-align:left">duration</td>
<td style="text-align:left">显示时间, 毫秒。设为 0 则不会自动关闭</td>
<td style="text-align:left">number</td>
<td style="text-align:left">-</td>
<td style="text-align:left">3000</td>
</tr>
</tbody>
</table>
<h3>Events</h3>
<table>
<thead>
<tr>
<th style="text-align:left">事件名称</th>
<th style="text-align:left">说明</th>
<th style="text-align:left">回调参数</th>
</tr>
</thead>
<tbody>
<tr>
<td style="text-align:left">onClose</td>
<td style="text-align:left">在 message 消失时触发</td>
<td style="text-align:left">-</td>
</tr>
</tbody>
</table>
</section></template>

<script>
  export default {
    methods: {
      open() {
        this.$message({
          content: '我是一个message'
        })
      },
      open1() {
        this.$message({
          type: 'success',
          content: '我是一个message'
        })
      },
      open2() {
        this.$message({
          type: 'warning',
          content: '我是一个message'
        })
      },
      open3() {
        this.$message({
          type: 'info',
          content: '我是一个message'
        })
      },
      open4() {
        this.$message({
          type: 'error',
          content: '我是一个message'
        })
      },
      open5() {
        this.$message({
          content: '<strong>这是 <i>HTML</i> 片段</strong>'
        })
      },
      open6() {
        this.$message({
          content: '这是一个message',
          verticalOffset: 100
        })
      },
      open7() {
        this.$message({
          content: '这是一个message',
          onClose: () => {
            console.log('message close');
          }
        })
      }
    }
  }
</script>